import { palette } from '@/theme/constants';

import { Box, Modal, Theme, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { MuiButton } from '@/components';

import Image from 'next/image';
import { useDispatch, useSelector } from 'react-redux';
import { openPublishModal } from '@/store/actions';
import { storySelector } from '@/store/selectors';
import { useRouter } from 'next/router';
import { styles } from './styles';
import { Form } from './Form';

interface ModalDetailProps {
  extendedPalette?: any;
  add: boolean;
  onClose: () => void;
  mediaContent?: any;
  method: () => void;
}

export const ManageCollaborators = ({ add, onClose, extendedPalette, method }: ModalDetailProps) => {
  const { t } = useTranslation();

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const story = useSelector(storySelector);
  const router = useRouter();
  const dispatch = useDispatch();

  const handleCollaboratorClick = () => {
    dispatch(openPublishModal());
    onClose();
  };

  return (
    <Modal open={add} onClose={onClose} sx={styles.modal}>
      <Box
        display={'flex'}
        width={isMobile ? '100%' : '100%'}
        mx={'0'}
        height={isMobile ? '100%' : '100%'}
        paddingTop={isMobile ? '4rem' : ''}
        maxHeight={isMobile ? '100%' : '100%'}
        bgcolor={`rgba(33, 45, 109, 0.8)`}
        flexDirection={'column'}
        justifyContent={isMobile ? 'flex-start' : 'center'}
        alignItems={'center'}
        alignContent={'center'}
        position={'relative'}
        overflow={'hidden'}>
        <Box
          width={'350px'}
          maxWidth={'100%'}
          height={'580px'}
          maxHeight={isMobile ? '100%' : '100%'}
          position={'absolute'}
          p={2}
          borderRadius={'20px'}
          alignItems={'center'}
          textAlign={'center'}
          overflow={'auto'}
          bgcolor={palette?.white}>
          {/* Title */}
          <Typography fontSize={'1rem'} color='#000000' textAlign='left' my={2}>
            People with Access
          </Typography>

          <Form onClose={onClose} extendedPalette={extendedPalette} />

          {/* Footer Text */}

          <MuiButton
            method={onClose}
            height='58px'
            sx={{
              backgroundColor: '#212D6D',
              color: 'white',
              gap: '1rem',
              py: 1.5,
              borderRadius: '10px',
              '&:hover': { backgroundColor: '#212D6D' },
            }}>
            <Image priority src={'/icons/tick.svg'} width={13} height={13} alt='tick' />
            <Typography fontSize={'1rem'} color='#F1F7FA'>
              Done
            </Typography>
          </MuiButton>
          <Typography
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={handleCollaboratorClick}
            fontSize={'0.9rem'}
            color='#000000'
            my={2}
            textAlign='center'>
            Want to invite more collaborators?
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};
